export default function Loading() {
    return (
        <div
            className='d-flex justify-content-center'
            style={{
            width: '100%',
            alignItems: 'center',
            height: '500px'
        }}>
            <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
            </div>
        </div>
    )
}